import React from 'react';
import clsx from 'clsx'; // Ensure clsx is installed or use template literals if preferred

// We extend HTMLAttributes so 'onClick', 'id', etc. are valid props
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const Card: React.FC<CardProps> = ({ 
  children, 
  className, 
  ...props // Capture other props like onClick
}) => {
  return (
    <div 
      className={clsx(
        "bg-white rounded-lg shadow-md border border-gray-100 overflow-hidden",
        className
      )}
      {...props} // Spread them to the div
    >
      {children}
    </div>
  );
};